import React, { useState, useEffect, useCallback } from 'react';
import styles from "./Declaration.module.scss";
import {
    CheckboxSelector,
    Button
  } from "@onegovbugs/onegov-react-components";

export const Declaration = ({props, continueButtonHandler, saveApplication}) => {
    
    const [agreeDeclaration, setAgreeDeclaration] = useState([]);

    const defaultCheckboxValue = {
      value: 1,
      label: "I agree to all of the above"
    };
  
    const checkboxValues = [defaultCheckboxValue];

    return (
        <div className={styles.mainCont}>
            <div className={styles.borderBox}>
            <div className={"row"}>
                <div className={"col-12"}>
                <div className={styles.content}>
                    <h2>
                     Declaration by applicant
                    </h2>
                    <p>
                        I, the applicant, applying for this Import/Export Licence, a class of biodiversity conservation licence under Part 2 of the <i>Biodiversity Conservation Act 2016</i>, 
                        acknowledge that it is an offence under the <i>Biodiversity Conservation Act 2016</i> to provide false or misleading information in, or in connection with this 
                        application and I state the information I have provided is true and correct. 
                        By clicking the “I agree” button below, I also acknowledge I will be required to comply with conditions of my Licence and any other statutory obligations. 
                    </p>
                    <p>
                        <h3>Information provided in licence applications</h3>
                        It is an offence under the <i>Biodiversity Conservation Act 2016</i> to provide false or misleading information in, or in connection with a licence application.   
                    </p>
                    <p>
                        <h3>Licence conditions</h3>
                        All licences are issued with strict conditions. It is an offence under the <i>Biodiversity Conservation Act 2016</i> to contravene a condition of a licence. 
                        The licensee and any associated organisation on the licence must have read and understood all licence <a target='_blank' href='https://www.environment.nsw.gov.au/-/media/OEH/Corporate-Site/Documents/Licences-and-permits/import-export-licence-conditions-190387.pdf?la=en&hash=7849C7869AAD13ACFECC5A6BC8288C39BF3A7DB1'>conditions</a> 
                        before undertaking activities authorised by this licence. before undertaking activities authorised by this licence.  
                    </p>
                    <p>
                        <h3>Prior compliance matters </h3>
                        If the licensee or associated organisation on the licence has been investigated or convicted of an offence in the last 10 years in relation to any law 
                        concerning the protection, conservation or management of native species or ecological communities, or had a biodiversity conservation licence or similar 
                        permit suspended or cancelled, details must be provided with the application as an attachment.  
                    </p>
                    <p>
                        <h3>Other statutory requirements</h3>
                        The licensee or associated organisation must ensure the interstate party has acted in accordance with other interstate statutory or regulatory provisions 
                        relevant to this licence. 
                    </p>
                    <p>
                        <h3>Privacy statement</h3>
                        This application form requests information that identifies you and is defined as ‘personal information’ under the NSW <i>Privacy and Personal Information Act 1998</i>. 
                        Information supplied on this form will be used by delegated officers of the Department of Planning, Industry and Environment to assess your application and will be 
                        entered into a computer system for granting licences. You may access and amend your personal information at any time by contacting the Department.  
                    </p>
                    <p>
                        <h3>Public register</h3>
                        As required by the <i>Biodiversity Conservation Act 2016</i>, a public register of biodiversity conservation licences is published on the Department website. 
                        The public register does not include personal information of individuals (e.g. name, postal and email address, phone number and date of birth), but does 
                        include the postcode of the licensee.  
                    </p>                                                  
                </div>
                <div className={styles.agreeCheckbox}>
                    <CheckboxSelector
                    onSelectionChange={v => {
                        setAgreeDeclaration(v);
                    }}
                    initialValue={agreeDeclaration}
                    options={checkboxValues}
                    />
                </div>
                </div>
            </div>
            </div>
            <div className={`row `+ styles.topMargin128}>
            <div className={`col-12`}>
                <Button
                    disabled={agreeDeclaration != 1}
                    onClick={() => {
                        continueButtonHandler();
                    }}
                >
                Continue
                </Button>
                <Button
                secondary
                onClick={() => {
                    saveApplication();
                }}
            >
                Save & exit section
            </Button>
            </div>
            </div>
        </div>      

    )
}